import { Component, Input } from '@angular/core';
import { DialogService } from '@ddt-web/dialog';

import { SimpleDcrContentDialogComponent } from '../simple-dcr-content-dialog/simple-dcr-content-dialog.component';

@Component({
	selector: 'ac-cta-dialog',
	templateUrl: './cta-dialog.component.html',
	styleUrls: ['./cta-dialog.component.scss']
})
export class CtaDialogComponent {

	@Input() public icon: string = 'arrow-right';
	@Input() public linkEvent: string;

	@Input() private dcrDialogTitle: string | string[];
	@Input() private dcrDialogContent: string | string[];
	@Input() private dcrDialogDisclaimer: string;

	constructor(
		private dialogService: DialogService
	) { }

	public showDialog(): void {
		this.dialogService.open(SimpleDcrContentDialogComponent, {
			showClose: true,
			data: {
				titleDCRKey: this.dcrDialogTitle,
				contentDCRKey: this.dcrDialogContent,
				disclaimerDCRKey: this.dcrDialogDisclaimer
			}
		});
	}
}
